module.exports = {"152923001":"额济纳旗航空街道","152923002":"额济纳旗东风街道","152923100":"达来呼布镇","152923101":"额济纳旗东风镇","152923102":"哈日布日格德音乌拉镇","152923200":"额济纳旗赛汉陶来苏木","152923201":"额济纳旗马鬃山苏木","152923202":"额济纳旗苏泊淖尔苏木","152923203":"巴彦陶来苏木","152923204":"温图高勒苏木"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152923.json
// module id = 498
// module chunks = 0